import React, { useState, useEffect } from "react";
import { Layout, Menu, Card, Typography } from "antd";
import { motion, AnimatePresence } from "framer-motion";
import pose1 from "../../Assets/Breathe/pose1.jpg";
import pose2 from "../../Assets/Breathe/pose2.jpg";
import pose3 from "../../Assets/Breathe/pose3.jpg";
import pose4 from "../../Assets/Breathe/pose4.jpg";
import pose5 from "../../Assets/Breathe/pose5.jpg";
import pose6 from "../../Assets/Breathe/pose6.jpg";
import sider1 from "../../Assets/Breathe/sider.jpg";
const { Sider, Content } = Layout;
const { Title, Paragraph } = Typography;

const DummyBreathe = () => {
  const mobileBreakpoint = 768;

  const [selectedKey, setSelectedKey] = useState("home");
  const [isMobile, setIsMobile] = useState(false);

  // Responsive Handler
  useEffect(() => {
    const updateUI = () => setIsMobile(window.innerWidth < mobileBreakpoint);
    updateUI();
    window.addEventListener("resize", updateUI);
    return () => window.removeEventListener("resize", updateUI);
  }, []);

  const handleLeftMenu = (e) => setSelectedKey(e.key);

  const siderWidth = isMobile ? "100%" : "200px";

  // Animations
  const fadeSlide = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
    exit: { opacity: 0, y: -20, transition: { duration: 0.4 } },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { type: "spring", stiffness: 60, damping: 12 },
    },
  };

  const cardStyle = {
    padding: "20px",
    borderRadius: "12px",
    margin: "0 auto 40px auto",
    width: "100%",
    maxWidth: "900px",
    boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
  };

  const pages = {
    home: (
      <>
        <Title level={2} style={{ textAlign: "center" }}>
          Breathe Technique
        </Title>
        <Paragraph
          style={{
            textAlign: "center",
            maxWidth: 700,
            margin: "10px auto",
            lineHeight: 1.7,
          }}
        >
          Here I have mentioned some breathing exercises that I know. Apart from
          this, please send us any other breathing exercises you know and
          register on our website, and help everyone who loves yoga in the
          world.
        </Paragraph>
        <h2
          style={{
            textAlign: "center",
            maxWidth: 700,
            margin: "10px auto",
          }}
        >
          Types of breathing exercises.
        </h2>

        <p
          style={{
            textAlign: "center", color: "blue",
          }}
        >
          How to manage breathing during yoga postures
        </p>
        <p
          style={{
            textAlign: "center", color: "red"
          }}
        >
          Pranayama (Breath management)
        </p>
      </>
    ),
    left1: (
      <>
        <motion.div
          style={{
            background: "rgba(255,255,255,0.9)",
      padding: "24px",
      borderRadius: "12px",
      margin: "0 auto 40px auto",
      width: "100%",
      maxWidth: "900px",
      boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
          }}
          variants={cardVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <h1
            style={{ color: "#00796b", fontWeight: "600", textAlign: "center" }}
          >
            How to manage breathing during yoga postures
          </h1>
          <h2 style={{ marginTop: "25px" }}>
            Three positions are used in this.
          </h2>
          <ol style={{ paddingLeft: "20px" }}>
            <li>Normal breathing</li>
            <li>Exhale</li>
            <li>Inhale</li>
            <li>Deep breathing</li>
          </ol>
        </motion.div>
        <motion.div variants={cardVariants} whileHover={{ scale: 1.02 }}>
          <Card
            bordered={false}
            style={{ ...cardStyle, background: "rgba(255,255,255,0.9)" }}
          >
            <h2 style={{ color: "#0c5c78", marginTop: "25px" }}>
              1. Normal breathing:
            </h2>
            <p>
              This is suitable for asanas that can be done without straining the
              body.
            </p>
            <p>
              <b>Example: Padmasana,vajrasana.</b>
            </p>
            <img
              src={pose1}
              alt="pose1"
              style={{
                width: "100%",
                maxWidth: "450px",
                height: "auto",
                display: "block",
                margin: "20px auto",
                borderRadius: 8,
                transition: "transform 0.3s ease",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.transform = "scale(1.05)")
              }
              onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
            />
            <p>
              These two asanas are great asanas for meditation and breathing
              practice.
            </p>
          </Card>
        </motion.div>
        <motion.div variants={cardVariants} whileHover={{ scale: 1.02 }}>
          <Card
            bordered={false}
            style={{ ...cardStyle, background: "rgba(255,255,255,0.9)" }}
          >
            <h2 style={{ color: "#0c5c78", marginTop: "25px" }}>2. Exhale:</h2>
            <p>
              <b>
                This helps when practicing yoga in forward bend, side bend and
                twist positions.
              </b>
            </p>
            <p>
              <strong>a. Forward bend:</strong> During these asanas, the chest
              and abdomen contract. Keeping the stomach empty helps the stomach
              contract, and exhaling helps the chest contract, making it easier
              to do forward bends.
            </p>
            <p>
              <b>example: Balasana</b>
            </p>
            <img
              src={pose2}
              alt="pose2"
              style={{
                width: "100%",
                maxWidth: "450px",
                height: "auto",
                display: "block",
                margin: "20px auto",
                borderRadius: 8,
                transition: "transform 0.3s ease",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.transform = "scale(1.05)")
              }
              onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
            />
            <p>
              <strong>b . Side bend:</strong> This asana involves bending the
              body to the side, which causes the pelvis to contract, and the
              chest to contract. Exhaling makes these asanas easier to do.
            </p>
            <p>
              <b>example: Parighasana</b>
            </p>
            <img
              src={pose3}
              alt="pose3"
              style={{
                width: "100%",
                maxWidth: "350px",
                height: "auto",
                display: "block",
                margin: "20px auto",
                borderRadius: 8,
                transition: "transform 0.3s ease",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.transform = "scale(1.05)")
              }
              onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
            />
            <p>
              <strong>c . Twist:</strong> In this position, the stomach and
              chest are twisted, making it easier to twist the body as you
              exhale.
            </p>
            <p>
              <b>example: Ardha Matsyendrasana</b>
            </p>
            <img
              src={pose4}
              alt="pose4"
              style={{
                width: "100%",
                maxWidth: "350px",
                height: "auto",
                display: "block",
                margin: "20px auto",
                borderRadius: 8,
                transition: "transform 0.3s ease",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.transform = "scale(1.05)")
              }
              onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
            />
            <p>
              <strong>d . Backbend:</strong> These asanas are easier to do by
              pressing the stomach to the floor and doing backbends.
            </p>
            <p>
              <b>example: Dhanurasana</b>
            </p>
            <img
              src={pose5}
              alt="pose5"
              style={{
                width: "100%",
                maxWidth: "350px",
                height: "auto",
                display: "block",
                margin: "20px auto",
                borderRadius: 8,
                transition: "transform 0.3s ease",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.transform = "scale(1.05)")
              }
              onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
            />
          </Card>
        </motion.div>
        <motion.div variants={cardVariants} whileHover={{ scale: 1.02 }}>
          <Card
            bordered={false}
            style={{ ...cardStyle, background: "rgba(255,255,255,0.9)" }}
          >
            <h2 style={{ color: "#0c5c78", marginTop: "25px" }}>3. Inhale:</h2>
            <p>
              <b>Inhale:</b> Inhaling helps the chest and diaphragm expand,
              making it easier to do backbends.
            </p>
            <p>
              <b>example: Chakrasana</b>
            </p>
            <img
              src={pose6}
              alt="pose6"
              style={{
                width: "100%",
                maxWidth: "350px",
                height: "auto",
                display: "block",
                margin: "20px auto",
                borderRadius: 8,
                transition: "transform 0.3s ease",
              }}
              onMouseOver={(e) =>
                (e.currentTarget.style.transform = "scale(1.05)")
              }
              onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
            />
          </Card>
        </motion.div>
        <motion.div variants={cardVariants} whileHover={{ scale: 1.02 }}>
          <Card
            bordered={false}
            style={{ ...cardStyle, background: "rgba(255,255,255,0.9)" }}
          >
            <h2 style={{ color: "#0c5c78", marginTop: "25px" }}>
              4. Deep Breathing:
            </h2>
            <p>
              This is done by taking a deep breath at the end of each asana to
              energize the body and give peace and tranquility to the mind.
            </p>
            <p>
              <b>example: Between each asana</b>
            </p>
            <p>
              <b>Precautions:</b>
            </p>
            <ol style={{ paddingLeft: "20px" }}>
              <li>
                It is better to do everything in this as per the advice of a
                yoga teacher near you.
              </li>
              <li>
                People with respiratory problems, heart disease, and blood
                pressure should practice simple or whatever is easy for them as
                per the advice of the doctor.
              </li>
              <li>
                Women should not do asanas or breathing exercises that can
                compress the stomach during menstruation and pregnancy. Do
                simple things for yourself as advised by a yoga expert and
                doctor.
              </li>
            </ol>
          </Card>
        </motion.div>
      </>
    ),
    left2: (
      <>
        <Card
          style={{
            maxWidth: "900px",
            margin: "20px auto",
            padding: "24px",
            borderRadius: "14px",
            background: "#ffffff",
            boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
           
            lineHeight: "1.7",
          }}
        >
          <Typography.Title
            level={2}
            style={{ textAlign: "center", marginBottom: "20px", color: "#333" }}
          >
            Pranayama
          </Typography.Title>

          <Typography.Paragraph style={{ fontSize: "1rem" }}>
            Pranayama is a Sanskrit word. It is made up of two words:
          </Typography.Paragraph>

          <ul style={{ marginLeft: "20px" }}>
            <li>
              <strong>Prana</strong>: life force, life energy, the energy that
              flows through the body through breathing.
            </li>
            <li>
              <strong>Ayama</strong>: extension, expansion, control.
            </li>
          </ul>

          <Typography.Paragraph style={{ fontSize: "1rem", marginTop: "16px" }}>
            Therefore, Pranayama means{" "}
            <strong>"extension and control of the life force"</strong>. It is
            not just breathing practice, but the art of controlling the subtle
            energy (prana) present in the body. Pranayama is a very important
            yogic practice that integrates the mind and body.
          </Typography.Paragraph>

          <Typography.Paragraph style={{ fontSize: "1rem" }}>
            The natural process of breathing does not just involve the expansion
            and contraction of the lungs. Breathing here is done consciously,
            following certain restrictions. Therefore,Pranayama is a way to
            increase the <strong>Prana Shakti</strong> or life force.Controlled
            breathing is possible through Pranayama.
          </Typography.Paragraph>

          <Typography.Title
            level={4}
            style={{ marginTop: "24px", color: "#0c5c78" }}
          >
            Pranayama consists of 3 phases of breathing.
          </Typography.Title>

          <ul style={{ marginLeft: "20px" }}>
            <li>
              <strong>Inhalation (Puraka)</strong>: This is the process of
              inhaling air, in which the chest expands, and the diaphragm is
              pushed down.
            </li>
            <li>
              <strong>Retention (Kumbhaka)</strong>: This means holding the
              breath after inhaling (Andar Kumbhaka) or exhaling (Bhahya
              Kumbhaka). Retention is a very powerful technique in Pranayama,
              which induces the relaxation response.
            </li>
            <li>
              <strong>Exhalation (Rechaka)</strong>: This is the phase of
              expelling the impure air in a smooth and continuous manner. In
              this process, the abdominal muscles help to expel the lungs and
              raise the diaphragm.
            </li>
          </ul>

          <Typography.Title
            level={4}
            style={{ marginTop: "24px", color: "#0c5c78" }}
          >
            How to Do Pranayama
          </Typography.Title>

          <Typography.Paragraph style={{ fontSize: "1rem" }}>
            Those who practice Nadi Shudhi should spread a blanket or mat in a
            well-ventilated place. Drink a little milk or water and practice.
          </Typography.Paragraph>

          <Typography.Title
            level={4}
            style={{ marginTop: "24px", color: "#0c5c78" }}
          >
            Nadi Shudhi
          </Typography.Title>

          <Typography.Paragraph style={{ fontSize: "1rem" }}>
            You can do Nadi Shudhi between asanas and when you feel tired. When
            you breathe normally, the air goes only to the chest. In Nadi
            Shudhi, it goes to the Muladhara.
          </Typography.Paragraph>

          <Typography.Paragraph style={{ fontSize: "1rem" }}>
            Nadi Shudhi provides clean blood to the 7200 Nadi nerves in our
            body. If you do Nadi Shudhi while looking at the rising sun or
            setting sun, the ultra-violet energy in the light mixes with the
            air. It gives us clarity of mind, eliminates nervous tension that
            causes hunger. It increases alertness. It helps prevent diseases
            like asthma and nasal congestion.
          </Typography.Paragraph>
          <Typography.Paragraph style={{ fontSize: "1rem" }}>
            I have only told you what I know. Please send us other breathing
            exercises that you know.
          </Typography.Paragraph>

          <Typography.Title
            level={2}
            style={{ textAlign: "center", marginBottom: "20px" }}
          >
            Why Should You Do Pranayama?
          </Typography.Title>

          <Typography.Paragraph style={{ fontSize: "1rem" }}>
            The main purpose of doing pranayama is to align the body, mind, and
            soul. Its direct and indirect benefits are many:
          </Typography.Paragraph>

          {/* PHYSICAL BENEFITS */}
          <Typography.Title
            level={4}
            style={{ color: "#0c5c78", marginTop: "24px" }}
          >
            1. Physical Benefits
          </Typography.Title>

          <ul style={{ marginLeft: "20px" }}>
            <li>
              <strong>
                Increases the amount of oxygen delivered to the body:
              </strong>{" "}
              Long, deep breathing provides sufficient oxygen to all the cells
              of the body.
            </li>
            <li>
              <strong>Strengthens the respiratory system:</strong> Increases the
              capacity of the lungs and helps control problems like asthma and
              shortness of breath.
            </li>
            <li>
              <strong>Calms the nervous system:</strong> It acts as a natural
              anti-stress agent. Reduces anxiety and worry.
            </li>
            <li>
              <strong>Improves cardiovascular health:</strong> Regulates the
              heart rate and helps control blood pressure.
            </li>
            <li>
              <strong>Improves digestion:</strong> The rhythmic movement of
              breathing stimulates the digestive organs and improves digestion.
            </li>
            <li>
              <strong>Boosts immunity:</strong> As stress decreases, the body's
              immunity increases.
            </li>
          </ul>

          {/* MENTAL BENEFITS */}
          <Typography.Title
            level={4}
            style={{ color: "#0c5c78", marginTop: "24px" }}
          >
            2. Mental & Psychological Benefits
          </Typography.Title>

          <ul style={{ marginLeft: "20px" }}>
            <li>
              <strong>Sharpens the mind:</strong> Increased oxygen flow to the
              brain improves concentration, memory, and thinking skills.
            </li>
            <li>
              <strong>Emotional control:</strong> Gives us the power to control
              emotions like anger, anxiety, and depression.
            </li>
            <li>
              <strong>Peace and clarity:</strong> Calms the mind and brings
              inner clarity. Mental waves (siddha vrittis) begin to subside.
            </li>
            <li>
              <strong>Improves sleep:</strong> Deep and refreshing sleep is
              achieved due to mental peace.
            </li>
          </ul>

          {/* SPIRITUAL BENEFITS */}
          <Typography.Title
            level={4}
            style={{ color: "#0c5c78", marginTop: "24px" }}
          >
            3. Spiritual Benefits
          </Typography.Title>

          <ul style={{ marginLeft: "20px", color: "#444" }}>
            <li>
              <strong>Regulates the flow of inner energy:</strong> According to
              the yoga scriptures, our body has nadis (energy channels).
              Pranayama removes blockages in these nadis and regulates the flow
              of prana.
            </li>
            <li>
              <strong>Helps in meditation:</strong> The mind can be controlled
              through breathing. A steady, deep breath is a basic requirement
              for meditation. "Breath is the horse of the mind" is the proverb.
            </li>
            <li>
              <strong>
                Establishes connection with the inner self (the true nature of
                the self):
              </strong>{" "}
              Helps us transcend the layers of the body and mind and experience
              the inner spiritual essence.
            </li>
          </ul>

          {/* WARNINGS */}
          <Typography.Title
            level={4}
            style={{ marginTop: "28px", color: "#b30000" }}
          >
            Important Warnings
          </Typography.Title>
          <Typography.Paragraph style={{ fontSize: "1rem" }}>
            Pranayama is a powerful practice. Therefore, there are some{" "}
          </Typography.Paragraph>
          <Typography.Title
            level={4}
            style={{ color: "#0c5c78", marginTop: "24px" }}
          >
            important things to note:
          </Typography.Title>

          <ul style={{ marginLeft: "20px" }}>
            <li>
              <strong>Beginner’s Guide:</strong> It is better to do complex
              pranayama like Kumbhaka and Bhastrika under the guidance of a
              trained asan (guru) in the beginning.
            </li>
            <li>
              <strong>Start slowly:</strong> Start with simple exercises like
              Nadi Sodhana (Alternate Nose Breathing).
            </li>
            <li>
              <strong>Medical conditions:</strong> Some pranayama should be
              avoided in situations like high blood pressure, heart disease,
              breast surgery, pregnancy. Consult a doctor first.
            </li>
            <li>
              <strong>Do it on an empty stomach: </strong> It is best to do it
              in the morning, when the stomach is empty.
            </li>
          </ul>

          {/* CONCLUSION */}
          <Typography.Title level={4} style={{ marginTop: "28px" }}>
            Conclusion
          </Typography.Title>

          <Typography.Paragraph style={{ fontSize: "1rem" }}>
            Pranayama is not just a breathing exercise; it is a science that
            directly manipulates the life force. It is a powerful tool for
            physical health, mental peace, and a higher spiritual life. With
            regular practice, breathing can completely transform your mind and
            life.
          </Typography.Paragraph>

          <Card
            style={{
              background: "#f7faff",
              padding: "16px",
              borderRadius: "10px",
              marginTop: "20px",
              border: "1px solid #dce9ff",
            }}
          >
            <Typography.Text style={{ fontSize: "1rem" }}>
              🌿 <strong>Get Started:</strong> Begin your Pranayama journey
              today with just
              <strong> 5 minutes of deep breathing.</strong>
            </Typography.Text>
          </Card>
        </Card>
      </>
    ),
    "3-1": (
      <>
        <Card
          style={{
            maxWidth: "900px",
            margin: "20px auto",
            padding: "24px",
            borderRadius: "14px",
            background: "#ffffff",
            boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
           
            lineHeight: "1.7",
          }}
        >
          <Typography.Title
            level={3}
            style={{ textAlign: "center", marginBottom: "16px", color: "#333" }}
          >
            1. Bhastrika Breathing Exercise
          </Typography.Title>

          {/* Image Section */}
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <img
              src="/assets/bhastrika.jpg"
              alt="Bhastrika Breathing"
              style={{
                width: "100%",
                maxWidth: "350px",
                height: "auto",
                borderRadius: "12px",
                objectFit: "cover",
                display: "block",
                margin: "0 auto",
              }}
            />
          </div>

          {/* Instructions */}
          <Typography.Paragraph style={{ fontSize: "1rem" }}>
            Close the right nostril with the thumb of the right hand and inhale
            the air through the left nostril without stopping. Immediately close
            the left nostril with the ring finger of the right hand and exhale
            slowly through the right nostril. Again, inhale the air through the
            right nostril without stopping. Immediately close the right nostril
            with the thumb of the right hand and exhale through the left
            nostril. Do this 10 times.
          </Typography.Paragraph>

          {/* Benefits */}
          <Typography.Title level={4} style={{ marginTop: "24px" }}>
            Benefits:
          </Typography.Title>
          <Typography.Paragraph style={{ fontSize: "1rem" }}>
            Diseases do not approach. Diseases such as swelling of the neck,
            weakness, diseases related to the penis, chest pain, fever, cough,
            asthma, cold, gas, bile, phlegm, body heat etc. will be cured. Blood
            circulates well.
          </Typography.Paragraph>
        </Card>
      </>
    ),
    "3-2": (
      <>
        <Card
          style={{
            maxWidth: "900px",
            margin: "20px auto",
            padding: "24px",
            borderRadius: "14px",
            background: "#ffffff",
            boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
           
            lineHeight: "1.7",
          }}
        >
          <Typography.Title
            level={3}
            style={{ textAlign: "center", marginBottom: "16px", color: "#333" }}
          >
            2. Kapalpati breathing exercise
          </Typography.Title>

          {/* Image Section */}
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <img
              src="/assets/bhastrika.jpg"
              alt="Bhastrika Breathing"
              style={{
                width: "100%",
                maxWidth: "350px",
                height: "auto",
                borderRadius: "12px",
                objectFit: "cover",
                display: "block",
                margin: "0 auto",
              }}
            />
          </div>

          {/* Instructions */}
          <Typography.Paragraph style={{ fontSize: "1rem" }}>
            Breathe in through both nostrils and exhale quickly without
            stopping. Do this 10 times.
          </Typography.Paragraph>

          {/* Benefits */}
          <Typography.Title level={4} style={{ marginTop: "24px" }}>
            Benefits:
          </Typography.Title>
          <Typography.Paragraph style={{ fontSize: "1rem" }}>
            All kinds of diseases will be cured. Beauty will be gained. If
            people with high voice do this exercise, their voice will decrease.
          </Typography.Paragraph>
        </Card>
      </>
    ),
    "3-3": (
      <>
        <Card
          style={{
            maxWidth: "900px",
            margin: "20px auto",
            padding: "24px",
            borderRadius: "14px",
            background: "#ffffff",
            boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
           
            lineHeight: "1.7",
          }}
        >
          <Typography.Title
            level={3}
            style={{ textAlign: "center", marginBottom: "16px", color: "#333" }}
          >
            3. Ujjayi breathing exercise
          </Typography.Title>

          {/* Image Section */}
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <img
              src="/assets/bhastrika.jpg"
              alt="Bhastrika Breathing"
              style={{
                width: "100%",
                maxWidth: "350px",
                height: "auto",
                borderRadius: "12px",
                objectFit: "cover",
                display: "block",
                margin: "0 auto",
              }}
            />
          </div>

          {/* Instructions */}
          <Typography.Paragraph style={{ fontSize: "1rem" }}>
            To increase your body's energy, take a deep breath through both
            nostrils and hold it for 10 to 60 seconds, then exhale very slowly
            through both nostrils.
          </Typography.Paragraph>

          {/* Benefits */}
          <Typography.Title level={4} style={{ marginTop: "24px" }}>
            Benefits:
          </Typography.Title>
          <ul style={{ marginLeft: "20px", color: "#444" }}>
            <li>
              This increases the amount of oxygen that mixes with the blood in
              our body and activates all the organs of the body.
            </li>
            <li>
              This breathing exercise uses your lungs to their full capacity by
              filling and emptying them completely.
            </li>
            <li>
              For those who are practicing this for the first time, start with a
              10-second hold and gradually increase it.
            </li>
            <li>
              Do not wear clothes that constrict your chest during breathing and
              yoga exercises. This will prevent your chest from expanding fully.
            </li>
            <li>
              Headaches will go away and facial skin will glow. Cough and cold
              will go away.
            </li>
          </ul>
        </Card>
      </>
    ),
    "3-4": (
      <>
        <Card
          style={{
            maxWidth: "900px",
            margin: "20px auto",
            padding: "24px",
            borderRadius: "14px",
            background: "#ffffff",
            boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
           
            lineHeight: "1.7",
          }}
        >
          <Typography.Title
            level={3}
            style={{ textAlign: "center", marginBottom: "16px", color: "#333" }}
          >
            4. Sheetali breathing exercises
          </Typography.Title>

          {/* Image Section */}
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <img
              src="/assets/bhastrika.jpg"
              alt="Bhastrika Breathing"
              style={{
                width: "100%",
                maxWidth: "350px",
                height: "auto",
                borderRadius: "12px",
                objectFit: "cover",
                display: "block",
                margin: "0 auto",
              }}
            />
          </div>

          {/* Instructions */}
          <Typography.Paragraph style={{ fontSize: "1rem" }}>
            Sheetali means coolness. The tongue should be extended out like a
            tube and rolled up and slowly released through the tube-like part of
            the tongue. This should be done 10 times.
          </Typography.Paragraph>

          {/* Benefits */}
          <Typography.Title level={4} style={{ marginTop: "24px" }}>
            Benefits:
          </Typography.Title>
          <Typography.Paragraph style={{ fontSize: "1rem" }}>
            Body heat will subside. This exercise can be done to protect the
            body from heat. Eye irritation and headache will be relieved.
          </Typography.Paragraph>
        </Card>
      </>
    ),
    "3-5": (
      <>
        <Card
          style={{
            maxWidth: "900px",
            margin: "20px auto",
            padding: "24px",
            borderRadius: "14px",
            background: "#ffffff",
            boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
           
            lineHeight: "1.7",
          }}
        >
          <Typography.Title
            level={3}
            style={{ textAlign: "center", marginBottom: "16px", color: "#333" }}
          >
            5. Sheetkari breathing exercises
          </Typography.Title>

          {/* Image Section */}
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <img
              src="/assets/bhastrika.jpg"
              alt="Bhastrika Breathing"
              style={{
                width: "100%",
                maxWidth: "350px",
                height: "auto",
                borderRadius: "12px",
                objectFit: "cover",
                display: "block",
                margin: "0 auto",
              }}
            />
          </div>

          {/* Instructions */}
          <Typography.Paragraph style={{ fontSize: "1rem" }}>
            Sheetkari, Pranayama is added. Breathe in with your mouth open and
            your tongue folded in. Breathe in through your mouth and slowly
            exhale through your nostrils without stopping. Do this 10 time
          </Typography.Paragraph>
        </Card>
      </>
    ),
  };

  const selectedContent = pages[selectedKey];
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      style={{
        padding: "50px 20px",
        background: "linear-gradient(to bottom right, #f0f9ff, #fff)",
        minHeight: "100vh",
       
        fontSize: "18px",
        lineHeight: "1.8",
      }}
    >
      <Layout
        style={{
          width: isMobile ? "100%" : "90%",
          maxWidth: "1340px",
          background: "#fff",
          borderRadius: "16px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          overflow: "hidden",
          height: "auto",
        }}
      >
        {/* 🌿 LEFT SIDEBAR */}
        <motion.div
          initial={{ x: -80, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          style={{
            width: isMobile ? "100%" : "200px",
            height: isMobile ? "auto" : "100%",
          }}
        >
          <Sider
            width={isMobile ? "100%" : 240}
            style={{
              position: isMobile ? "relative" : "sticky",
              top: isMobile ? "0px" : "64px", // FIXED
              marginTop: isMobile ? "60px" : "40px",
              height: isMobile ? "auto" : "calc(100vh - 64px)",
              minHeight: isMobile ? "250px" : "unset",
              backgroundImage: `url(${sider1})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              overflow: "hidden",
              borderRight: isMobile
                ? "none"
                : "1px solid rgba(255,255,255,0.2)",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "rgba(0, 0, 0, 0.6)",
                zIndex: 1,
              }}
            />

            {/* 🌿 Sidebar Content */}
            <div
              style={{
                position: "relative",
                zIndex: 2,
                padding: "16px",
                fontWeight: "bold",
                textAlign: "center",
                color: "#fff",
                fontSize: "1rem",
                letterSpacing: "0.5px",
                textShadow: "0 1px 3px rgba(0,0,0,0.8)",
              }}
            >
              {" "}
              Breathe Techniques
            </div>

            <Menu
              theme="transparent"
              mode="inline"
              style={{
                background: "transparent",
                color: "#fff",
                fontSize: "1.1rem",
                position: "relative",
                zIndex: 2,
                fontWeight: 500,
                textAlign: "center",
              }}
              onClick={handleLeftMenu}
              selectedKeys={[selectedKey]}
              items={[
                {
                  key: "left1",
                  label: "Manage Breathing",
                },
                {
                  key: "left2",
                  label: "Pranayama",
                },
                {
                  key: "left3",
                  label: "Types",
                  children: [
                    { key: "3-1", label: "Bhastrika " },
                    { key: "3-2", label: "Kapalpati " },
                    { key: "3-3", label: "Ujjayi" },
                    { key: "3-4", label: "Sheetali " },
                    { key: "3-5", label: "Sheetkari " },
                  ],
                },
                { key: "home", label: "Back to Mainpage" },
              ]}
            />
          </Sider>
        </motion.div>

        {/*  MAIN CONTENT */}
        <Content
          style={{
            flex: 1,
            padding: isMobile ? "10px" : "30px 40px",
            width: "100%",

            background: "#fff",
            textAlign: "left",
          }}
        >
          <AnimatePresence mode="wait">
            <motion.div
              key={selectedKey}
              variants={fadeSlide}
              initial="hidden"
              animate="visible"
              exit="exit"
            >
              
                {selectedContent}
              
            </motion.div>
          </AnimatePresence>
        </Content>
      </Layout>
    </motion.div>
  );
};

export default DummyBreathe;
